import React from 'react';
import NotificationSource from '../../assets/app-icons/notification.svg';
import CalendarSource from '../../assets/app-icons/calendar.svg';
import TeamAvailabilitySource from '../../assets/app-icons/team_availability.svg';
import PersonalAvailabilitySource from '../../assets/app-icons/event_personal.svg';
import TeamMembersSource from '../../assets/app-icons/event_team.svg';
import VodReviewSource from '../../assets/app-icons/vod_review.svg';
import TeamStatsSource from '../../assets/app-icons/team_stats.svg';
import CommentsSource from '../../assets/app-icons/comments.svg';
import GuideLibrarySource from '../../assets/app-icons/guide_library.svg';
import GuideHubSource from '../../assets/app-icons/agent_mastery_guides.svg';
import GraphSource from '../../assets/app-icons/graph.svg';
import MapMacroSource from '../../assets/app-icons/map_macro.svg';
import CoordinatedPlaySource from '../../assets/app-icons/coordinated_playbooks.svg';
import ProAnalysisSource from '../../assets/app-icons/pro_player_analysis.svg';
import LfgSource from '../../assets/app-icons/LFG.svg';
import './AppIcons.css';
function AppIcon({source,size=16,className='',style,title,strokeWidth,fill,...props}) {
 const labelled=!!props['aria-label'];
 return <span aria-hidden={labelled?undefined:true} role={labelled?'img':undefined} {...props} title={title} className={'app-svg-icon '+className} style={{width:size,height:size,'--app-icon-source':'url('+JSON.stringify(source)+')',...style}}/>;
}
export const NotificationIcon=props=><AppIcon {...props} source={NotificationSource}/>;
export const CalendarIcon=props=><AppIcon {...props} source={CalendarSource}/>;
export const TeamAvailabilityIcon=props=><AppIcon {...props} source={TeamAvailabilitySource}/>;
export const PersonalAvailabilityIcon=props=><AppIcon {...props} source={PersonalAvailabilitySource}/>;
export const TeamMembersIcon=props=><AppIcon {...props} source={TeamMembersSource}/>;
export const VodReviewIcon=props=><AppIcon {...props} source={VodReviewSource}/>;
export const TeamStatsIcon=props=><AppIcon {...props} source={TeamStatsSource}/>;
export const CommentsIcon=props=><AppIcon {...props} source={CommentsSource}/>;
export const GuideLibraryIcon=props=><AppIcon {...props} source={GuideLibrarySource}/>;
export const GuideHubIcon=props=><AppIcon {...props} source={GuideHubSource}/>;

export const GraphIcon=props=><AppIcon {...props} source={GraphSource}/>;
export const MapMacroIcon=props=><AppIcon {...props} source={MapMacroSource}/>;
export const CoordinatedPlayIcon=props=><AppIcon {...props} source={CoordinatedPlaySource}/>;
export const ProAnalysisIcon=props=><AppIcon {...props} source={ProAnalysisSource}/>;
export const LfgIcon=props=><AppIcon {...props} source={LfgSource}/>;
